module.exports = __webpack_public_path__ + "./assets/img/landing_m.7c4ad642.png";